export { AdicionarDependenteComponent } from './adicionar-dependente/adicionar-dependente.component';
import { AdicionarTempoRppsComponent } from './adicionar-tempo-rpps/adicionar-tempo-rpps.component';
export { ExcluirDependenteComponent } from './excluir-dependente/excluir-dependente.component'
